<template>
  <div class="wallet-list">
    <button
      v-for="wallet in filteredWallets"
      :key="wallet.currency"
      class="wallet-list__item"
      @click="$emit('wallet-select', wallet.currency)"
    >
      <div class="wallet-list__icon">
        <CurrencyFlag :currency="wallet.currency" />
      </div>
      <div class="wallet-list__content">
        <h4>{{ wallet.currency }} Wallet</h4>
        <p>Available balance: {{ formatAmountToDollar(wallet.balance, 2, wallet.currency) }}</p>
      </div>
      <svg class="wallet-list__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button class="wallet-list__btn" @click="$emit('wallet-select', currency)">
      Continue
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import CurrencyFlag from "../CurrencyFlag.vue";
import { formatAmountToDollar } from "@/utils/helpers";

defineEmits(["wallet-select"]);

const store = useStore();

const walletBalance = computed(
  () => store.getters["organisationModule/walletBalance"]
);
const currency = computed(() => store.state.organisationModule.currency);
const filteredWallets = computed(() => {
  return walletBalance.value?.filter(
    (wallet) => wallet.currency !== currency.value
  );
});
</script>

<style lang="scss" scoped>
// Design System Variables
$text-primary: #0F172A;
$text-secondary: #475569;
$text-muted: #64748B;
$bg-subtle: #F1F5F9;
$border-color: #E2E8F0;
$btn-primary: #001240;
$btn-primary-hover: #06206B;

.wallet-list {
  // SideModal content has no padding in this app, so the list pads itself
  padding: 8px 24px;
  display: flex;
  flex-direction: column;

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 0;
    background: transparent;
    border: none;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;

    &:last-of-type {
      border-bottom: none;
    }

    &:hover {
      background: $bg-subtle;
      margin: 0 -16px;
      padding: 16px;
      width: calc(100% + 32px);
      border-radius: 8px;
      border-bottom-color: transparent;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $bg-subtle;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__content {
    flex: 1;

    h4 {
      font-size: 14px;
      font-weight: 600;
      color: $text-primary;
      margin: 0 0 2px;
    }

    p {
      font-size: 13px;
      color: $text-muted;
      margin: 0;
    }
  }

  &__arrow {
    color: $text-muted;
    flex-shrink: 0;
  }

  &__btn {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    background: $btn-primary;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: white;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: $btn-primary-hover;
    }
  }
}
</style>
